import Appointment from "../interface/appointment";
import getAppointmentStatusText from "./getAppointmentStatusText";

/**
 * A single row of the Excel export. Keys are the German column headers, in the
 * order the columns should appear. `Datum` is a real Date so Excel keeps it as a
 * date value; every other field is a string.
 */
export interface AppointmentExportRow {
  Datum: Date;
  Uhrzeit: string;
  Typ: string;
  "Teilnehmer:in": string;
  "Coach:in": string;
  Status: string;
  Telefon: string;
  "E-Mail": string;
  Standort: string;
  Qualifikation: string;
}

// Parses a "YYYY-MM-DD" date string into a Date at midnight UTC. exceljs derives
// the Excel serial number from Date.getTime(), i.e. from UTC — local midnight
// would land on the previous day in every timezone east of Greenwich.
const parseExcelDate = (date: string): Date => {
  const [year, month, day] = date.split("T")[0].split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day));
};

// Mirrors what the overview shows in the "Typ | Teilnehmer:in" column.
const getParticipantLabel = (appointment: Appointment): string => {
  if (appointment.isSpeedcoaching) return "Speedcoaching";
  return appointment.participantFullName ?? "Termin ist frei";
};

/**
 * Maps an appointment to a flat export row that mirrors the appointment
 * overview ("you get what you see"), plus the detail fields shown in the
 * expandable section.
 */
const mapAppointmentToExportRow = (
  appointment: Appointment,
): AppointmentExportRow => ({
  Datum: parseExcelDate(appointment.date),
  Uhrzeit: appointment.timeSlot,
  Typ: appointment.type ?? "",
  "Teilnehmer:in": getParticipantLabel(appointment),
  "Coach:in": appointment.coachFullName ?? "",
  Status: getAppointmentStatusText(appointment),
  Telefon: appointment.participantPhoneNumber ?? "",
  "E-Mail": appointment.participantEmail ?? "",
  Standort: appointment.participantLocation ?? "",
  Qualifikation: appointment.participantQualification ?? "",
});

export default mapAppointmentToExportRow;
